// FILE: /src/Components/Redirectpage/TiktokRedirect.js (FULLY UPDATED)

import React, { useEffect, useState } from "react";
import { Spin, message, Result, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as authServices from '../../services/authConnect';
import { handleAuthSuccess } from "../../store/Slices/GroupSlice";

export default function TiktokRedirect() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [status, setStatus] = useState('processing');

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');

            if (code && state) {
                try {
                    // This service now makes the backend call and waits for a JSON response
                    await authServices.handleCallback('TIKTOK', code, state);
                    message.success("TikTok connected successfully! Refreshing data...");
                    
                    // Dispatch action to refresh groups and profiles in Redux
                    dispatch(handleAuthSuccess());
                    
                    // Navigate user back to the main app
                    navigate('/Dashboard/GroupsProfile');

                } catch (err) {
                    setError(err.message || 'Failed to verify connection with TikTok.');
                    setStatus('error');
                }
            } else {
                setError('TikTok authentication was cancelled or failed.');
                setStatus('error');
            }
        };
        handleCallback();
    }, [dispatch, navigate]);

    if (status === 'error') {
        return (
            <Result
                status="error"
                title="Connection Failed"
                subTitle={error}
                extra={[
                    <Button type="primary" key="console" onClick={() => navigate('/Dashboard/GroupsProfile')}>
                        Go back to Brands & Channels
                    </Button>,
                ]}
            />
        );
    }

    return (
        <div className="flex flex-col justify-center items-center h-screen">
            <Spin size="large" />
            <p className="mt-4 text-lg text-gray-600">Finalizing TikTok connection...</p>
        </div>
    );
}